import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { IUsr0401MState, DeptDataType, ProjectDataType, UserDataType, ProjectSummaryType, BankProjectType } from '../../models/usr/usr0401m_model';

const initialState: IUsr0401MState = {
    data: [],
    activeTable: 'total',
    showDeptUserList: false,
    selectedDept: null,
    deptUserList: [],
    projectList: [],
    projectSummary: null,
    
    listFilter: 'total',
    projectListFilter: 'total',
    bankProjects: [],
    projectDetailList: [],
};

export const usr0401m_Slice = createSlice({
    name: "usr0401m_Slice",
    initialState,
    reducers: {
        setData: (state, action: PayloadAction<DeptDataType[]>) => { state.data = action.payload; },
        setActiveTable: (state, action: PayloadAction<string | null>) => { state.activeTable = action.payload; },
        setShowDeptUserList: (state, action: PayloadAction<boolean>) => { state.showDeptUserList = action.payload; },
        setSelectedDept: (state, action: PayloadAction<{ dept: string; key: string } | null>) => { state.selectedDept = action.payload; },
        setDeptUserList: (state, action: PayloadAction<UserDataType[]>) => { state.deptUserList = action.payload; },
        setProjectList: (state, action: PayloadAction<ProjectDataType[]>) => { state.projectList = action.payload; },
        setProjectSummary: (state, action: PayloadAction<ProjectSummaryType>) => { state.projectSummary = action.payload; },
        
        setListFilter: (state, action: PayloadAction<string>) => { state.listFilter = action.payload; },
        setProjectListFilter: (state, action: PayloadAction<string>) => { state.projectListFilter = action.payload; },
        setBankProjects: (state, action: PayloadAction<BankProjectType[]>) => { state.bankProjects = action.payload; },
        setProjectDetailList: (state, action: PayloadAction<ProjectDataType[]>) => { state.projectDetailList = action.payload; },
        
        initState: (state) => {
            Object.assign(state, initialState);
        }
    },
});

export default usr0401m_Slice.reducer;
export const Usr0401mAction = usr0401m_Slice.actions;